import { getNodeType, closest, } from '@tencent/exeditor3-core';
import { NAME as listItemName, LIST_GROUP, toggleList, closestList, isListNode, changeListStyle, } from '@tencent/exeditor3-plugin-list-item';
import { createIcon } from '@tencent/exeditor3-ui-kit/dist/icon.js';
import '@tencent/exeditor3-ui-kit/dist/list-style-palette.js';
import { getListStyleType } from './util.js';
import { bulletListName, defaultStyleListTypes, inputRegex, listStyleTypeMap, } from './conf.js';
export { inputRegex };
export class BulletListPlugin {
    initEditor(editor) {
        this.editor = editor;
    }
    constructor(ops) {
        this.name = bulletListName;
        /**
         *  ul 列表序号的样式
         * 目前有 circle（空心圆）、disc（实心圆）、square（实心方块）、\27A3（箭头）、
         * \2713（对号）、\2727（星星）6种序号样式。
         * 先从 ul 的样式 listStyleType 中读取默认值，默认为空心圆，点击编辑器工具栏中的有序列表下拉选框，可以切换不同的序号样式。
         */
        this.listStyleType = 'circle';
        // 可配置的有序列表类型，是个二维数组
        this.listStyleTypes = [[]];
        this.spec = {
            defining: false,
            type: 'node',
            childrenType: `${listItemName}+`,
            group: `block ${LIST_GROUP}`,
            matchSelector: 'ul',
            attrs: {
                listStyleType: {
                    default: this.listStyleType,
                    parse: (node) => {
                        const listStyleType = getListStyleType(node);
                        if (listStyleType) {
                            this.listStyleType = listStyleType;
                        }
                        return listStyleType || this.listStyleType;
                    },
                    toDOMAttribute: (listStyleType) => {
                        const finalType = (listStyleType === null || listStyleType === void 0 ? void 0 : listStyleType.trim()) || this.listStyleType;
                        const isUnicode = /\d/.test(finalType);
                        const className = isUnicode
                            ? 'unicode-list-style-type'
                            : 'nonUnicode-list-style-type';
                        const style = `--ul-list-style-type: ${
                        // unicode 值必须要用引号包裹
                        isUnicode ? `'${finalType}'` : `'${listStyleTypeMap[finalType]}'`}`;
                        return {
                            'data-list-style-type': finalType,
                            style,
                            class: className,
                        };
                    },
                },
            },
            toDOM: 'ul',
        };
        this.toggle = () => {
            const nodeType = getNodeType(this, this.editor.schemaInstance);
            const listItemNodeType = getNodeType(listItemName, this.editor.schemaInstance);
            this.editor.execute(toggleList(nodeType, listItemNodeType, {
                listStyleType: this.listStyleType,
            }));
        };
        this.isActive = () => {
            var _a;
            const { $from, $to } = this.editor.selection();
            // 粗略的判断，没有考虑重复 node、嵌套列表等
            return (((_a = closestList($from)) === null || _a === void 0 ? void 0 : _a.type.name) === this.name &&
                closestList($to) === closestList($from));
        };
        this.setListStyle = (listStyleType) => {
            const nodeType = getNodeType(this, this.editor.schemaInstance);
            changeListStyle(this.editor, nodeType, listStyleType, this.name);
        };
        this.listStyleTypes = (ops === null || ops === void 0 ? void 0 : ops.listStyleTypes) || defaultStyleListTypes;
    }
    capabilities() {
        return {
            commands: {
                toggle: this.toggle,
                isActive: this.isActive,
                setListStyle: this.setListStyle,
            },
            inputRules: [inputRegex],
            shortcuts: {
                'Mod-Shift-i': this.toggle,
            },
        };
    }
    renderToolbarItem() {
        const btn = document.createElement('exeditor-toolbar-button');
        Object.assign(btn, {
            label: this.editor.t('无序列表'),
            shortcut: 'Mod-Shift-i',
            separateDropdown: true,
        });
        btn.addEventListener('buttonclick', () => {
            this.editor.focus();
            this.toggle();
        });
        const icon = createIcon({
            name: this.name,
            editor: this.editor,
            fallback: () => import('./icon.js').then((m) => m.bulletListIcon),
        });
        const palette = this.renderPalette(btn);
        btn.append(icon, palette);
        this.editor.on('idlechange', () => {
            const isActive = this.isActive();
            if (isActive) {
                const { $from } = this.editor.selection();
                const { node: olNode } = closest($from, isListNode);
                const { listStyleType } = (olNode === null || olNode === void 0 ? void 0 : olNode.attrs) || {};
                palette.listStyleType = listStyleType || 'circle';
            }
            else {
                palette.listStyleType = '';
            }
        });
        return btn;
    }
    renderPalette(btn) {
        const palette = document.createElement('exeditor-list-style-palette');
        palette.slot = 'pop-content';
        palette.listType = 'ul';
        palette.listStyleTypes = this.listStyleTypes;
        palette.addEventListener('pick', (e) => {
            const listStyleType = e.detail || '';
            this.editor.focus();
            this.listStyleType = listStyleType;
            this.setListStyle(listStyleType);
            palette.listStyleType = listStyleType;
            btn.closeDropdown();
        });
        return palette;
    }
}
//# sourceMappingURL=index.js.map